var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.499 17.6904C29.5464 17.6904 28.7715 16.9149 28.7715 15.9623C28.7715 15.0097 29.5464 14.2348 30.499 14.2348C31.4518 14.2348 32.2266 15.0096 32.2266 15.9623C32.2266 16.9151 31.4518 17.6904 30.499 17.6904ZM11.4037 17.6904C10.4511 17.6904 9.67625 16.9149 9.67625 15.9623C9.67625 15.0097 10.451 14.2348 11.4037 14.2348C12.3563 14.2348 13.1312 15.0096 13.1312 15.9623C13.1312 16.9151 12.3565 17.6904 11.4037 17.6904ZM31.1186 7.28379L34.5714 1.30385C34.6664 1.13882 34.6921 0.942825 34.6428 0.758872C34.5935 0.574919 34.4733 0.418033 34.3084 0.322637C34.1434 0.227637 33.9474 0.201968 33.7635 0.251258C33.5795 0.300548 33.4227 0.420773 33.3272 0.585569L29.8313 6.64109C27.1577 5.42113 24.1553 4.74143 20.9514 4.74143C17.7475 4.74143 14.745 5.42113 12.0716 6.64109L8.5755 0.585569C8.48008 0.420773 8.32319 0.300548 8.13925 0.251258C7.95531 0.201968 7.75933 0.227637 7.59429 0.322637C7.42937 0.417943 7.30903 0.574831 7.25972 0.758821C7.21042 0.942811 7.23619 1.13885 7.33136 1.30385L10.7841 7.28379C4.85523 10.5084 0.800251 16.5106 0.207031 23.6019H41.6957C41.102 16.5108 37.047 10.5084 31.1186 7.28364",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.e9f42c87f8ce284b1eb9cab681112aac.svg";
export { ForwardRef as ReactComponent };